import { api } from "..";

const endpoint = "/api/shipments";
const containersEndpoint = "/api/shipment-containers";

// SHIPMENT
export const getShipmentList = (queryParams) => {
  return api.get(`${endpoint}`, { params: queryParams });
};

export const getShipmentDetail = (id) => {
  return api.get(`${endpoint}/${id}`);
};

export const addShipment = (data) => {
  return api.post(`${endpoint}`, data);
};

export const updateShipment = (id, data) => {
  return api.put(`${endpoint}/${id}`, data);
};

export const patchShipment = (id, data) => {
  return api.patch(`${endpoint}/${id}`, data);
};

export const deleteShipment = (id) => {
  return api.delete(`${endpoint}/${id}`);
};

// CONTAINERS
export const getShipmentContainersByShipmentId = (id) => {
  return api.get(`${containersEndpoint}/shipment/${id}`);
};

export const updateBatchShipmentContainers = (data) => {
  return api.put(`${containersEndpoint}/batch`, data);
};

//FILES
export const getShipmentFileList = (queryParams) => {
  return api.get(`${endpoint}/files`, { params: queryParams });
};

export const downloadShipmentFile = (id) => {
  return api.get(`${endpoint}/files/${id}`, {
    responseType: "blob",
    headers: { Accept: "*/*" },
  });
};

export const deleteShipmentFile = (id) => {
  return api.delete(`${endpoint}/files/${id}`);
};

export const uploadShipmentFiles = (data, file) => {
  const metadata = {
    ...data,
    shipmentId: data.id
  }
  const formData = new FormData();
  formData.append("metadata", JSON.stringify(metadata));
  formData.append("file", file, file.name);

  return api.post(`${endpoint}/upload/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

//EXPORT
export const exportShipments = (queryParams) => {
  return api.get(`${endpoint}/export`, { params: queryParams });
};

// PURCHASE ORDERS
const purchaseOrdersEndpoint = "/api/shipment-purchase-orders";

export const getShipmentPurchaseOrdersByShipmentId = (id) => {
  return api.get(`${purchaseOrdersEndpoint}/shipment/${id}`);
};

export const updateBatchShipmentPurchaseOrders = (data) => {
  return api.put(`${purchaseOrdersEndpoint}/batch`, data);
};
  